import React, {useRef, useState} from 'react';
import {UseLoader} from "../../../../hooks/useLoader";
import {UsePermissions} from "../../../../hooks/usePermissions";
import {convertirModena} from "../../../../shared/utils/utils";
import {ColumnGroup} from "primereact/columngroup";
import {Row} from "primereact/row";
import {Column} from "primereact/column";
import {Toast} from "primereact/toast";
import {DataTable} from "primereact/datatable";
import {confirmDialog} from "primereact/confirmdialog";
import {
    eliminarLiquidacion,
    traerDetalleliquidacion,
    traerDetalleliquidacionAsociado
} from "../../../../api/liquidacion.service";
import {ModalDeatailEvent} from "./ModalDeatailEvent";

export const TableEvento = ({liquidacion, factura, reload}) => {
    const toast = useRef(null);
    const [handleLoad] = UseLoader();
    const [permisos] = UsePermissions()
    const [showDeatail, setShowDeatail] = useState(false);
    const [dataEvent, setDataEvent] = useState([]);

    const onDelete = () => {
        confirmDialog({
            message: '¿Estas seguro?',
            header: 'Confirmación',
            acceptLabel: "Si",
            rejectLabel: "No",
            accept: async () => {
                const factura = new Set(liquidacion.map(item => item.factura_id))
                let factura_id = 0;
                factura.forEach(e => {
                    factura_id = e;
                })
                handleLoad(true);
                const payload = {
                    factura_id,
                    datos: liquidacion
                }
                const response = await eliminarLiquidacion(payload);

                handleLoad(false)

                if (response.estado !== 200) {
                    toast.current?.show({severity: 'error', summary: 'Alerta', detail: response.mensaje, life: 3000});
                    return;
                }

                toast.current?.show({severity: 'success', summary: 'Exito', detail: response.mensaje, life: 3000});
                reload()
            }
        });
    }


    const valorBrutoDistribucion = (porcentaje) => {
        for (let liq of liquidacion) {

            liq.valor = isNaN(Math.round(liq.valor_neto * (1 + porcentaje))) ? 0 : Math.round(liq.valor_neto * (1 + porcentaje));
        }
    }

    const valorNetoTotal = () => {
        let total = 0;
        let porceIndividual = 0;
        for (let liq of liquidacion) {

            total += liq.valor_neto === '' ? 0 : parseFloat(liq.valor_neto);
            porceIndividual = factura.valor_descuento / total;

        }
        valorBrutoDistribucion(porceIndividual)


        return convertirModena(total);
    }

    const valorBrutoTotal = () => {
        let total = 0;
        for (let liq of liquidacion) {
            total += liq.valor === '' ? 0 : parseFloat(liq.valor);
        }
        return convertirModena(total);
    }


    let footerGroup =
        <ColumnGroup>
            <Row>
                <Column footer="" colSpan={2} footerStyle={{marginLefth: '10px'}}/>
                <Column footer={valorNetoTotal}/>

                <Column footer={valorBrutoTotal}/>
            </Row>
            <Row>


            </Row>
        </ColumnGroup>;
    const onDetalleAso = async (rowData) => {
        try {
            handleLoad(true);
            const response = await traerDetalleliquidacionAsociado({
                factura_id: factura.factura_id,
                asociado_id: rowData
            });
            handleLoad(false);
            if (response.estado !== 200) {
                toast.current?.show({severity: 'error', summary: 'Alerta', detail: response.mensaje, life: 3000});
                return;
            }
            setDataEvent(response.data)
            setShowDeatail(true);
        } catch (e) {
            handleLoad(false);
            console.log(e)
        }
    }

    const actionTemplate = function (rowData) {
        return (
            <div className="flex align-items-center justify-start">

                <button
                    disabled={(!permisos.editar)}
                    className="btn primary-color-btn"
                    type="button"
                    onClick={() => onDetalleAso(rowData.asociado_id)}>
                    <i className="fa fa-edit"/>
                </button>
            </div>
        );
    }

    const ondetail = async () => {
        try {
            handleLoad(true);
            const response = await traerDetalleliquidacion({factura_id: factura.factura_id});
            handleLoad(false);
            if (response.estado !== 200) {
                toast.current?.show({severity: 'error', summary: 'Alerta', detail: response.mensaje, life: 3000});
                return;
            }
            setDataEvent(response.data)
            setShowDeatail(true);
        } catch (e) {
            handleLoad(false);
            console.log(e)
        }
    }

    const header = (
        <div className="flex align-items-center ">
            <div>
                <button
                    className="danger-color-btn btn"
                    type="button"
                    disabled={(!permisos.eliminar)}
                    onClick={onDelete}
                >
                    <i className="fa fa-trash"/>
                </button>
            </div>
            <div>
                <button
                    className="primary-color-btn btn"
                    type="button"
                    disabled={(!permisos.consultar)}
                    onClick={ondetail}
                >
                    <i className="fa fa-address-book"/>
                </button>
            </div>
        </div>
    );

    const footer = (
        <div className="flex align-items-center  ">
            <p className={'p-2 text-sm text-teal-600 '}>
                Valor factura: {convertirModena(factura.valor_neto)}</p>

        </div>
    );

    const valueBodyTemplateNeto = (rowData) => {
        return convertirModena(rowData.valor_neto);
    }
    const valueBodyTemplateBruto = (rowData) => {
        return convertirModena(rowData.valor);
    }

    const onHide = () => {
        setShowDeatail(false);
        setDataEvent([]);
    }
    return (
        <>
            <Toast ref={toast}/>
            <DataTable
                showGridlines
                value={liquidacion}
                size="small"
                editMode="cell"
                dataKey="id"
                header={header}
                footer={footer}
                scrollable scrollHeight="400px"
                footerColumnGroup={footerGroup}
                responsiveLayout="scroll">
                <Column header="Editar" style={{fontSize: ".8em", width: '5%'}} body={actionTemplate}/>
                <Column field="afiliados" filter sortable header="Afiliados" style={{width: '10%'}}></Column>
                <Column field="valor_neto" filter sortable body={valueBodyTemplateNeto} header="Valor neto"
                        style={{width: '10%'}}></Column>
                <Column field="valor" filter sortable body={valueBodyTemplateBruto} header="Valor bruto"
                        style={{width: '10%'}}></Column>


            </DataTable>
            <ModalDeatailEvent show={showDeatail} hide={onHide} fields={dataEvent}/>
        </>
    );
};


